import { gql } from '@grandvisionhq/graphql';

const GET_PRESCRIPTION_VALUES_FROM_DOCUMENT = gql`
  query GetPrescriptionValuesFromDocument($prescriptionDocument: PrescriptionDocumentInput!) {
    getPrescriptionValuesFromDocument(prescriptionDocument: $prescriptionDocument) {
      prescriptionValues {
        examDate
        expiryDate
        leftLens {
          baseCurve
          diameter
          power
          axisInt
          axisInt
          cylinder
          addition
          pupillaryDistance
        }
        opticianDetails {
          type
          opticianName
          streetName
          additionalStreetInfo
          additionalAddressInfo
          postalCode
          city
          country
          address
          region
        }
        rightLens {
          baseCurve
          diameter
          power
          axisInt
          axisInt
          cylinder
          addition
          pupillaryDistance
        }
      }
      resultCode
      resultMessage
      success
    }
  }
`;

export { GET_PRESCRIPTION_VALUES_FROM_DOCUMENT };
//# sourceMappingURL=get-prescription-values-from-document.js.map
